import { camelizeKeys } from "humps";
import { SET_CATALOGS } from "./types";

export default {
    [SET_CATALOGS]: (state, { type, data }) => {
        state.catalogs[type] = camelizeKeys(data);
    }
}